import React from 'react';
import ServicePageShell from '../../components/ServicePageShell';
import TironoutStatic from './TironoutStatic';

export default function Tironout() {
  return (
    <ServicePageShell
      strapiApiId="annexe-tironout"
      defaultSectionLabel="Annexes"
      defaultTitle="Tironout & Qualification Militaire"
      StaticFallback={TironoutStatic}
    />
  );
}
